import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../api/keys';
import { authClient } from './client';

export interface SessionUser {
  id: string;
  name: string;
  email: string;
  timezone: string | null;
}

interface RawUser {
  id: string;
  name: string;
  email: string;
  timezone?: string | null;
}

export function toSessionUser(user: RawUser): SessionUser {
  return { id: user.id, name: user.name, email: user.email, timezone: user.timezone ?? null };
}

export class SessionUnavailableError extends Error {
  constructor() {
    super('PainPal couldn’t be reached. Check your connection, then try again.');
    this.name = 'SessionUnavailableError';
  }
}

export async function fetchSessionUser(): Promise<SessionUser | null> {
  const { data, error } = await authClient.getSession();
  if (error) throw new SessionUnavailableError();
  return data?.user ? toSessionUser(data.user) : null;
}

export function sessionQueryOptions() {
  // No silent retries: the route error screen offers TRY AGAIN instead of a multi-second blank wait.
  return queryOptions({ queryKey: queryKeys.session, queryFn: fetchSessionUser, staleTime: 60_000, retry: false });
}

export async function signOut(): Promise<void> {
  const { error } = await authClient.signOut();
  if (error) throw new Error(error.message || 'Could not sign out');
}
